import React, { useMemo } from 'react';
import _ from 'underscore';
import { PrimaryButton } from 'app/blocks/buttons/buttons';
import { ID, l } from 'app/blocks/common/codes';
import { Checkbox } from 'app/ui/form';

type AlertsPanelProps = {
    alerts: {
        alertId: string;
        alertName: string;
        email: boolean;
        onScreen: boolean;
    }[];
    notificationEmail: string;
    myAccountHref: string;
    saveAlerts: () => void;
    toggleAlert: (id: string, checked: boolean) => void;
    isSaveEnabled: boolean;
};

const AlertsPanel: React.FC<AlertsPanelProps> = ({
    alerts,
    isSaveEnabled,
    myAccountHref,
    notificationEmail,
    saveAlerts,
    toggleAlert,
}) => {
    const ALERTS_NAME = useMemo(
        () => ({
            CITATION_UPDATES: l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.ALERTS_CITATION_UPDATES`),
            EARLY_VIEW: l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.ALERTS_EARLY_VIEW`),
            ISSUE_PUB_ONLINE: l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.ALERTS_ISSUE_PUB_ONLINE`),
        }),
        [],
    );

    const alertList = useMemo(() => alerts?.filter(({ onScreen }) => onScreen), [alerts]);

    return (
        <div className="AlertsPanel" data-seleniumid="alerts-block" id="alerts-panel-body">
            <div className="AlertsPanel-Headers">
                <div className="AlertHeader-SubHeader" data-seleniumid="alerts-content">
                    {l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.PROFILE_ACCNT_ALERTS_LABEL_TEXT`)},
                    <p className="AlertHeader-Email" data-seleniumid="alerts-content-email">
                        {' '}
                        {notificationEmail}
                    </p>
                    . {l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.PROFILE_ACCNT_ALERTS_LABEL_AFT_TEXT`)}
                    <a
                        data-seleniumid="myprofile-link"
                        href={myAccountHref}
                        id="myprofile-link"
                        rel="noreferrer"
                        target="_blank"
                    >
                        <b>{l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.ALERTS_PROFILE_LINK_LABEL`)}</b>
                    </a>
                    .
                </div>
            </div>
            <div className="AlertsPanel-Headers" data-seleniumid="myprofile-sub-content">
                <div className="AlertHeader-SubContent">
                    {l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.PROFILE_ACCNT_ALERTS_LABEL_SUB_HEADER`)}
                </div>
            </div>
            <div>
                {!_.isEmpty(alertList) ? (
                    alertList.map(alert => (
                        <div key={alert.alertId} className="AlertHeader-AlertRow" data-seleniumid={alert.alertId}>
                            <div className="Alert-Action">
                                <Checkbox
                                    checked={alert.email}
                                    data-seleniumid={`${alert.alertId}_CHECKBOX`}
                                    id={alert.alertId}
                                    onChange={e => {
                                        toggleAlert(alert.alertId, e.target.checked);
                                    }}
                                    value={alert.alertId}
                                />
                            </div>
                            <label htmlFor={alert.alertId}>
                                <div className="AlertHeader-Text" data-seleniumid={`${alert.alertId}_TEXT`}>
                                    {ALERTS_NAME[alert.alertId]}
                                </div>
                            </label>
                        </div>
                    ))
                ) : (
                    <div className="AlertsPanel-EmptyRow">
                        <p className="AlertsPanel-EmptyRow-Text">
                            {l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.PROFILE_ACCNT_NOT_AVAILABLE_LABEL`)}
                        </p>
                    </div>
                )}
            </div>
            <div className="AlertHeader-Actions">
                <PrimaryButton
                    className="Action"
                    data-seleniumid="alert-save-button"
                    disabled={!isSaveEnabled}
                    id="saveAlertsInfo"
                    onClick={saveAlerts}
                >
                    {l(`${ID.PROFILE_ACCOUNT}.uiLabelMessages.PROFILE_ACCNT_SAVE_CHANGES_BUTTON_LABEL`)}
                </PrimaryButton>
            </div>
        </div>
    );
};

export default AlertsPanel;
